const KEY_INTERNO = "proyectos_form_borrador_interno";
const KEY_PUBLICO = "proyectos_form_borrador_publico";

export function borradorStorageKey(publicMode: boolean): string {
  return publicMode ? KEY_PUBLICO : KEY_INTERNO;
}

export function guardarBorradorFormulario(
  publicMode: boolean,
  payload: { step: number; form: Record<string, unknown> },
): void {
  try {
    localStorage.setItem(
      borradorStorageKey(publicMode),
      JSON.stringify({ ...payload, savedAt: new Date().toISOString() }),
    );
  } catch {
    /* quota exceeded u otro */
  }
}

export function cargarBorradorFormulario(publicMode: boolean): {
  step: number;
  form: Record<string, unknown>;
} | null {
  try {
    const raw = localStorage.getItem(borradorStorageKey(publicMode));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    const step = Number(parsed.step);
    const form = parsed.form;
    if (!form || typeof form !== "object") return null;
    return {
      step: Number.isFinite(step) && step >= 0 ? step : 0,
      form: form as Record<string, unknown>,
    };
  } catch {
    return null;
  }
}

export function limpiarBorradorFormulario(publicMode: boolean): void {
  localStorage.removeItem(borradorStorageKey(publicMode));
}
